import Vue from 'vue'
import './plugins/vuetify'
import VueAnalytics from 'vue-analytics'
import App from './App.vue'


Vue.use(VueAnalytics, {
  id: 'UA-109163986-13'
})

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
